import { inject } from "@angular/core";
import { CanMatchFn, Router } from "@angular/router";

/** Sends a user that already has a session to the admin home instead of the login. */
export const loginGuard: CanMatchFn = () => {
  if (localStorage.getItem("token")) {
    return inject(Router).parseUrl("/admin");
  }
  return true;
};
